export const SET_HRESS5U_INDEX_DISP = 'SET_HRESS5U_INDEX_DISP'
export const GET_HRESS5U_INDEX_DISP = 'GET_HRESS5U_INDEX_DISP'
export const SET_HRESS5U_DETAIL_DISP = 'SET_HRESS5U_DETAIL_DISP'
export const GET_HRESS5U_DETAIL_DISP = 'GET_HRESS5U_DETAIL_DISP'
export const SET_HRESS5U_COLUMNS = 'SET_HRESS5U_COLUMNS'
export const GET_HRESS5U_COLUMNS = 'GET_HRESS5U_COLUMNS'
export const SET_HRESS5U_LABELS = 'SET_HRESS5U_LABELS'
export const GET_HRESS5U_LABELS = 'GET_HRESS5U_LABELS'
export const RECEIVED_HRESS5U_COLUMNS_LABELS = 'RECEIVED_HRESS5U_COLUMNS_LABELS'
export const SET_HRESS5U_INDEX = 'SET_HRESS5U_INDEX'
export const GET_HRESS5U_INDEX = 'GET_HRESS5U_INDEX'
export const RECEIVED_HRESS5U_INDEX = 'RECEIVED_HRESS5U_INDEX'
export const SET_HRESS5U_INDEX_SELECTED = 'SET_HRESS5U_INDEX_SELECTED'
export const GET_HRESS5U_INDEX_SELECTED = 'GET_HRESS5U_INDEX_SELECTED'
export const SET_HRESS5U_DETAIL = 'SET_HRESS5U_DETAIL'
export const GET_HRESS5U_DETAIL = 'GET_HRESS5U_DETAIL'
export const RECEIVED_HRESS5U_DETAIL = 'RECEIVED_HRESS5U_DETAIL'
export const TOGGLE_HRESS5U_PAGE = 'TOGGLE_HRESS5U_PAGE'
export const POST_HRESS5U_SEND_APPROVE = 'POST_HRESS5U_SEND_APPROVE'
export const GET_HRESS5U_DETAIL_TAB2_POPUP1 = 'GET_HRESS5U_DETAIL_TAB2_POPUP1'
export const SET_HRESS5U_DETAIL_TAB2_POPUP1 = 'SET_HRESS5U_DETAIL_TAB2_POPUP1'
export const RECEIVED_HRESS5U_DETAIL_TAB2_POPUP1 = 'RECEIVED_HRESS5U_DETAIL_TAB2_POPUP1'
export const GET_HRESS5U_DETAIL_TAB2_POPUP2 = 'GET_HRESS5U_DETAIL_TAB2_POPUP2'
export const SET_HRESS5U_DETAIL_TAB2_POPUP2 = 'SET_HRESS5U_DETAIL_TAB2_POPUP2'
export const RECEIVED_HRESS5U_DETAIL_TAB2_POPUP2 = 'RECEIVED_HRESS5U_DETAIL_TAB2_POPUP2'
export const RECEIVED_HRESS5U_DROPDOWNS = 'RECEIVED_HRESS5U_DROPDOWNS'



// WEBPACK FOOTER //
// ./src/store/modules/hress5u/mutation-types.js